import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { updateToken } from 'src/api/api';
import { unavailableAccountsMessage, updateAccountTokens } from 'src/api/accountTokens';
import { dropUnavailableFcAccounts, setErrorCode, setTokenRefreshStatus } from 'src/store/actions/loginAction';
import { IRootReducer } from 'src/store/reducers';
import { loginSelector } from 'src/store/selectores/loginSelectors';
import { PassengersErrorMessagesEnum } from 'src/types/global';
import { RefreshTokenStatus } from 'src/types/login';

const useRefreshToken = (): void => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const [isLoading, setIsLoading] = useState(false);

    const { fcAccounts, refreshTokenStatus, token } = useSelector((state: IRootReducer) =>
        loginSelector(state)
    );

    useEffect(() => {
        if (!isLoading && (refreshTokenStatus === RefreshTokenStatus.Invalid || !refreshTokenStatus)) {
            dispatch(setErrorCode(PassengersErrorMessagesEnum.GenralError));
            setIsLoading(true);

            updateAccountTokens(fcAccounts, ({ proxyUrl, contactUUID, dbUrl }) =>
                updateToken({ token, proxyUrl, dbUrl, contactUUID })
            ).then(({ available, unavailable }) => {
                // Ok first: dropping a company changes fcAccounts, and this effect would run again on an Invalid status
                if (available.length || !fcAccounts.length) dispatch(setTokenRefreshStatus(RefreshTokenStatus.Ok));
                setIsLoading(false);
                dropUnavailableFcAccounts(unavailable, unavailableAccountsMessage(unavailable, t));
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refreshTokenStatus, fcAccounts, token, dispatch]);
};

export default useRefreshToken;
